import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
  constructor() {}

  //
  // Ensure that a number is not "NaN". If it is, throw an error that tells the user that they need to correct the value they have entered.
  //
  validateNumberField(value: number, fieldName: string) {
    if (Number.isNaN(value)) {
      throw Error(`Please enter a valid value in ${fieldName}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/utils.service.ts